import styled from 'styled-components';
import { baseVariables } from '@marriott/mi-ui-library';
import { chatKeyboardFocusVisible } from '../../styles/chatFocus';

export const CardWrapper = styled.div<{ $clickable?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: var(--general-spacer-02, 8px);
  padding: var(--general-spacer-02, 8px);
  border-radius: var(--t-cards-border-radius, 14px);
  background-color: var(--t-brand-bg-color, #ffffff);
  overflow: hidden;
  width: 304px;
  max-width: 304px;
  position: relative;
  cursor: ${props => (props.$clickable ? 'pointer' : 'default')};
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  // @media ${baseVariables.mediaQuery.md} {
  //   width: 311px;
  // }
  @media (max-width: 576px) {
    box-shadow: 0 6px 6px rgba(0, 0, 0, 0.08);
  }
    
  &:hover {
    ${props =>
      props.$clickable &&
      `
      box-shadow: 0 6px 6px rgba(0, 0, 0, 0.08);
      // transform: translateY(-2px);
    `}
  }
`;

export const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
  background-color: #f4f4f4;

  /* Style AImage component to fill container */
  picture {
    display: block;
    width: 100%;
    height: 100%;
  }

  img,
  .property-card-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    aspect-ratio: 16/9;
  }
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

export const BestMatchBadge = styled.div`
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 1;

  /* Override MTag padding to match Figma: 4px left, 8px right */
  > div {
    padding-left: var(--general-spacer-01, 4px);
    padding-right: var(--general-spacer-02, 8px);
  }
`;

export const BadgeIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
`;

export const BadgeText = styled.span`
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  color: var(--t-brand-fg-color, #1c1c1c);
  white-space: nowrap;
`;

export const FavoriteButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: none;
  background-color: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(12.5px);
  -webkit-backdrop-filter: blur(12.5px);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1;
  padding: 0;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(0, 0, 0, 0.6);
  }

  ${chatKeyboardFocusVisible}

  svg {
    width: 16px;
    height: 16px;
    color: white;
  }
`;

export const FavoriteSaveButtonWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;

  /* Override SaveHotelButton default positioning to make it relative to our wrapper */
  > div {
    position: static;
  }

  .icon-container {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background-color: rgba(0, 0, 0, 0.45);
    backdrop-filter: blur(12.5px);
    -webkit-backdrop-filter: blur(12.5px);

    &:hover {
      background-color: rgba(0, 0, 0, 0.6);
    }

    ${chatKeyboardFocusVisible}

    /* Icon styling */
    .icon-heart-outline,
    .icon-heart-fill {
      font-size: 16px;
    }
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--general-spacer-01, 4px);
  padding: 0 var(--general-spacer-01, 4px);
  width: 100%;
`;

export const HotelDescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--general-spacer-01, 4px);
  width: 100%;
`;

export const HotelName = styled.p`
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`;

export const RatingDistanceRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
`;

export const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 12px;
  height: 12px;
  flex-shrink: 0;

  svg {
    width: 12px;
    height: 12px;
  }
`;

export const DistanceGroup = styled.div`
  display: flex;
  align-items: center;
  gap: var(--general-spacer-01, 4px);
  height: 16px;
  flex: 1;
  min-width: 0;
`;

export const DistanceText = styled.span`
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
  color: var(--t-brand-alt-color, #707070);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
`;

export const DescriptionWrapper = styled.div`
  width: 100%;

  .wmde-markdown {
    background: transparent;
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    color: inherit;
  }

  p,
  ul,
  ol,
  li {
    margin: 0;
    padding: 0;
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    color: inherit;
  }

  ul,
  ol {
    padding-left: 1.25rem;
  }
`;

export const RateBarWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--general-spacer-01, 4px) 0;
  width: 100%;
  overflow: hidden;
`;

export const RateContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--general-spacer-01, 4px);
  flex: 1;
  min-width: 0;
`;

export const RateBlock = styled.div`
  display: flex;
  align-items: baseline;
  gap: var(--general-spacer-01, 4px);
  line-height: 1.25;
`;

export const Price = styled.span`
  font-size: 14px;
  font-weight: 700;
  line-height: 1.25;
  color: var(--t-brand-fg-color, #1c1c1c);
  flex-shrink: 0;
`;

export const CurrencyText = styled.span`
  font-size: 12px;
  font-weight: 700;
  line-height: 1.25;
  color: var(--t-brand-fg-color, #1c1c1c);
  flex-shrink: 0;
`;
